module.exports = __webpack_public_path__ + "img/icn_footer_youtube_round.cd09823b.svg";